import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { ShareMapService } from '../../app-share-map-module/share-map.service';
import { CsvFileDownloadService } from '../../_services/csv-file-download.service'
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
// import { QueryBuilderConfig } from 'angular2-query-builder';
import { NgxAngularQueryBuilderModule, QueryBuilderConfig } from 'ngx-angular-query-builder';
// import * as MapboxDraw from "@mapbox/mapbox-gl-draw";
// import DrawRectangle from 'mapbox-gl-draw-rectangle-mode';
// import {DirectMode,SimpleSelectMode,CircleMode,DragCircleMode} from 'mapbox-gl-draw-circle';
import { MaphelperService } from 'src/app/app-analysis-module/maphelper.service';
// import { NotificationMessageComponent } from '../../common-module/notification-message/notification-message.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { LoginSignupModalComponent } from 'projects/library-login-signup-module/src/lib/login-signup-modal/login-signup-modal.component';import { AuthService } from 'src/app/_services';
import { IsochroneService } from 'src/app/isochrone-module/isochrone.service';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MapShareService } from 'src/app/map-share.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material-module/app-material.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModuleModule } from 'src/app/common-module/common-module.module';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-proximity-analysis',
  standalone:true,
  imports:[
    MatIconModule,
    CommonModule,
    FlexLayoutModule,
    CommonModuleModule,
    AppMaterialModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    MatListModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatOptionModule,
    MatStepperModule,
    MatRadioModule,
    NgxAngularQueryBuilderModule,
  ],
  templateUrl: './proximity-analysis.component.html',
  styleUrls: ['./proximity-analysis.component.css'],
  // encapsulation: ViewEncapsulation.None,
})
export class ProximityAnalysisComponent implements OnInit {
  matFirstStep = false
  matSecondStep = false
  hideFalg: boolean;

  matThirdStep = false
  firstLayerDetailsSelected
  secondLayerDetailsSelected
  @ViewChild('stepper') stepper: MatStepper
  @Input() mapLayers: [];
  @Input() componentName;
  @Input() moduleName;
  @Input() circleradius: [];
  @Input() mapCarto;
  @Input() isSharedMap;
  // @Output() proximityOperationGeometry = new EventEmitter<any>();
  @Output() removeLayer = new EventEmitter<any>();
  @Output() addToMapLayers = new EventEmitter<any>();
  @Input() ResetFromMap;

  @Output() layerResfreshAfterPublish = new EventEmitter<any>();
  @Input() mapId: any;
  objArray: any;
  downloadDisabled: boolean = false;
  gidArray = []
  layerIdForPublish: any;
  publishLayerDisbled: boolean = false;
  BoundingCordinates;
  abc;
  @Input() draw
  proximityLayer;
  config: QueryBuilderConfig;
  allowRuleset: any;
  allowCollapse: any;
  allLayersData;
  IsQueryBuilder = true;
  filter_type = "and";
  query;
  buttonLoader: boolean = false;
  circleRadius1 = 100;
  isCircleBox = false;
  isLoggedIn: any;
  AddMore: boolean = true
  visible_one: boolean = true
  is_publish_button:boolean


  constructor(private router: Router, private authenticationService: AuthService, private _isochroneService: IsochroneService, private matDialog: MatDialog, private appAnalysisService: AppAnalysisService, private ShareMapService: ShareMapService, private CsvFileDownloadService: CsvFileDownloadService,
    private maphelperService: MaphelperService, private MapShareService: MapShareService,
  ) {
    // const modes = MapboxDraw.modes;
    // modes.draw_rectangle = DrawRectangle;
    // modes.draw_circle  = CircleMode;
    // modes.drag_circle  = DragCircleMode;
    // modes.direct_select =  DirectMode,
    // modes.simple_select= SimpleSelectMode;
    // this.draw = new MapboxDraw({
    //   displayControlsDefault: false,
    //   userProperties: true,
    //   modes: modes,
    // });

  }


  selectedOperation: any = "within";
  firstLayerSelected;

  secondLayerSelected
  bounding_coordinates;
  length;
  isProxyMultiple;
  selection = "oneLayer";
  proximityOperations = [
    { value: 'within', text: 'are within' },
    { value: 'intersects', text: 'intersects' },
    { value: 'closer', text: 'are closer than' },
    { value: 'further', text: 'are farther than' },
    { value: 'outside', text: 'are outside' }
  ];
  oneLayerProximityOperations = [
    { value: 'within', text: 'are within' },
    { value: 'intersects', text: 'intersects' }
  ];
  showDiv() {
    this.hideFalg = false;
  }
  onChangeRadius;
  ngOnInit() {
    this.MapShareService.mapemit.subscribe(data => {
      this.mapCarto = data
    })
    this.MapShareService.drawemit.subscribe(data => {
      this.draw = data
    })
    this.MapShareService.layersemit.subscribe(data => {
      this.mapLayers = data
    })
    this._isochroneService.initializeMapCursorPopUp();
    if (this.isSharedMap) {
      // this.mapCarto.addControl(this.draw)
    }
    // this.authenticationService.isLoggedIn.subscribe((data) => {
    //   this.isLoggedIn = this.authenticationService.isAuthenticated();
    // })
    // if (this.isLoggedIn == false) {
    //   const dialogRef = this.matDialog.open(LoginSignupModalComponent, {
    //     width: '75%',
    //     data: { loginModel: true, ModuleName: 'PROXIMITY' }
    //   });
    //   return
    // }

    this.maphelperService.ListenMapPopup.next(true);

    this.allLayersData = this.mapLayers;
    this.mapCarto.on('draw.create', (e) => {
      this.abc = JSON.stringify(e.features[0].geometry);
      console.log("on draw", e)
      this.isdrawingActive = false;
    })
    this.mapCarto.on('draw.update', (e) => {
      console.log('on update', e)
      this.abc = JSON.stringify(e.features[0].geometry);
      this.circleRadius1 = Math.round(e.features[0].properties.radiusInKm);
      this.isdrawingActive = false;
    });

    this.setDefaultValueQueryBuilder();
    // this.mapCarto.addControl(this.draw);
    // this.StylingVizualtionComponent.Isvisible()
  }

  ngAfterViewInit(): void {
    this._isochroneService.setModuleName("filter-tool")
  }



  async nextStep() {
    await this.ngOnChanges
    this.stepper.next()
  }

  onChange(data) {
    console.warn(data)
    console.warn(this.circleRadius1)
    this.drawCircle1()
  }

  featureHide() {
    if(this.isSharedMap){
    this.hideFalg = true; // this code will hide the div element since we have added the *ngIf
  }else{
    if(this.mapId){
          this.router.navigateByUrl(`/map-analysis/gis-analysis/${this.mapId}`)
    }else{
      this.router.navigateByUrl(`/map-analysis/gis-analysis/dashboard`)

    }
  }
}

  ngOnChanges(changes: SimpleChanges) {

    this.allLayersData = this.mapLayers;

    if (!this.isSharedMap) {
      if (this.mapLayers.length < 2) {
        this.matFirstStep = true;
        this.nextStep()
      }
    }


    console.log('click rest from map', this.ResetFromMap)
    if (this.ResetFromMap) {
      this.onResetButton();
    }
    // else if(this.mapCarto){
    //   console.log("this is getting called again ",this.draw);
    //   // this.mapCarto.addControl(this.draw);
    // }

  }

  setDefaultValueQueryBuilder() {
    // Set Default Value in CustomFilter
    let x = { gid: { name: 'gid', type: 'number', value: 'gid' } }
    this.config = { fields: x };
    this.query = {
      condition: this.filter_type,
      rules: [{ field: "gid", operator: '', value: "", entity: "" }]
    };
  }


  isdrawingActive = false;
  drawCircle1() {
    this.isdrawingActive = true;
    this.maphelperService.ListenMapPopup.next(false);
    console.log(this.circleRadius1)
    this.isCircleBox = true;
    this.draw.deleteAll();

    this._isochroneService.showCursorPopUpOnMap(this.mapCarto, "Click to draw cirle")
    this.draw.changeMode('draw_circle', { initialRadiusInKm: this.circleRadius1 });
    // this.drawCircle.emit(true)
    console.log("bounding coorinates in circle === ", this.abc);
  }

  drawPolygon1() {
    this.isdrawingActive = true
    this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    this.draw.deleteAll();
    this._isochroneService.showCursorPopUpOnMap(this.mapCarto, "Click to start drawing and finish it by double click")
    this.draw.changeMode('draw_circle', { initialRadiusInKm: this.circleRadius1 });
    console.log("is polygon working");
    this.draw.changeMode('draw_polygon');
    console.log("bounding coorinates in polygon === ", this.abc);
  }

  drawFreeHand1() {
    this.isdrawingActive = true
    this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    this.draw.deleteAll();
    this._isochroneService.showCursorPopUpOnMap(this.mapCarto, "Click to start drawing and finish it by double click")
    console.log("is free hand working");
    // this.draw.changeMode('draw_freehand');
    this.draw.changeMode('draw_polygon');
    console.log("bounding coorinates in free hand === ", this.abc);
  }

  drawRectangle1() {
    this.isdrawingActive = true
    this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    this.draw.deleteAll();
    this._isochroneService.showCursorPopUpOnMap(this.mapCarto, "Click to start drawing and finish it by single click")
    console.log("Draw Rectangle");
    this.draw.changeMode('draw_rectangle');
    console.log("bounding coorinates in rectangle === ", this.abc);
    // this.drawRectangle.emit(true)
  }

  clickClearAll() {
    this.maphelperService.ListenMapPopup.next(true);
    this.isCircleBox = false;
    this.draw.deleteAll();
    this.abc = "";
  }


  // Start Custom Filter
  idLayer: any;
  attributes: any;
  subFields: any = { age: { name: ' ', type: '' } }

  layerIdChange(Id) {
    this.findLabel = true
    this.matSecondStep = true
    this.idLayer = Id;
    this.setDefaultValueQueryBuilder();
    this.allLayersData.forEach(layer => {
      if (layer.layerid == Id) {
        this.firstLayerDetailsSelected = layer
        console.log('fetching attributes');
        this.attributes = layer.attributes;
        this.mapCarto.fitBounds(layer.fitBounds);
      }
    });
    this.subFields = {};
    this.attributes.forEach(sub => {
      let dataType = "";
      if (sub.data_type === "Numeric" || sub.data_type === 'integer' ||
        sub.data_type == "bigint" || sub.data_type == "double precision") {
        dataType = "number";
      } else {
        dataType = "string";
      }
      this.subFields[sub.column_name] = { name: sub.column_name, type: dataType }
    });

    this.config = { fields: this.subFields };
    console.log('attri sub field  ', this.config);
  }


  onFilterChange(e) {
    console.log(e.value)
    this.query['condition'] = e.value;
  }


  selectedLayerData;
  conditionalData;
  oldLayerId;
  findLabel = true
  nextStepper() {
    if (this.matSecondStep == false) {
      this.findLabel = false
    }
    this.stepper.selected.completed = true;
    this.stepper.next()
  }

  checkLayerTypeForTwoLayer() {
    // if(this.selectedOperation == "within" && this.selection=='twoLayer'){
    //   // if(this.firstLayerDetailsSelected.layer_type == this.secondLayerDetailsSelected.layer_type){
    //   //   this.nextStepper()
    //   // }
    //   // else{
    //   //   this._isochroneService.openSnackBar("Please select same layer","snackbar-error","fail");
    //   // }
    // }
    // else{
    this.nextStepper()
    this._isochroneService.removeCursorPopUpFromMap(this.mapCarto)
    // }
  }

  onProximitygetResult(firstLayerSelected, secondLayerSelected, selectedOperation, circleradius, BoundingCordinates, selection) {
    this.matThirdStep = true
    this.buttonLoader = true;
    this.draw.deleteAll()
    console.log(firstLayerSelected, secondLayerSelected, selectedOperation, circleradius, BoundingCordinates, selection);

    let length;
    if (this.length) {
      length = this.length / 100;
    }
    if (this.proximityLayer) {
      this.maphelperService.removeLayerFromMap(this.mapCarto, this.proximityLayer, this.isProxyMultiple)
      this.proximityLayer = "";
    }

    console.log(this.query['rules'].length);
    // Opertion Tool API and Validation
    if (this.query['rules'].length == 0) {
      // this.query.condition = "";
      this.conditionalData = "";
    }
    else if (this.query['rules'][0]) {
      this.conditionalData = this.query;
    }
    if (secondLayerSelected == undefined) {
      secondLayerSelected = "";
    }

    circleradius = null;
    console.log(this.query);
    if (this.conditionalData.rules[0].value == "") {
      this.conditionalData = ""
    }
    let x = {
      "bounding_coordinates": this.abc,
      "find_layerid": firstLayerSelected,
      "select_layerid": secondLayerSelected,
      "option": selectedOperation,
      "length": this.length,
      "condition_data": this.conditionalData == "" ? "" : JSON.stringify(this.conditionalData),
      "mapId":this.mapId
    }

    let OperationApi;
    if (this.isSharedMap) {
      OperationApi = this.ShareMapService.ShareMapOperationTool(x)
    } else {
      OperationApi = this.ShareMapService.OperationTool(x)
    }


    console.log(x);
    OperationApi.subscribe(val => {
      let finalResult = val.data;
      this.is_publish_button=val.data.is_publish_button;




      if (val.data.feature_count > 0) {
        this.maphelperService.getLayerJsonData(finalResult.dbzxvuwyacs, finalResult.view).subscribe(data => {


          //http://0.0.0.0:7800/mapschema_159631_17.view_layertable_202123_17/{z}/{x}/{y}.pbf?update=0.07155937450215522
          let url = Globals.vectorTileURL;
          url = url + finalResult.dbzxvuwyacs + "." + finalResult.view + "/{z}/{x}/{y}.pbf" + "?update=" + Math.random()
          console.log("url", url);

          console.log("Op layer", data);
          let tileurl = data["tileurl"] + "?update=" + Math.random();
          console.log(tileurl)
          let layerMapDetails = this.maphelperService.addLayers(finalResult.dbzxvuwyacs + "." + finalResult.view, data["geometrytype"], url, this.mapCarto, 0, "red");

          this.proximityLayer = layerMapDetails.source;
          this.isProxyMultiple = layerMapDetails.multiple;
          this.mapCarto.fitBounds(data['bounds']);
          this.mapCarto = layerMapDetails.map;
          finalResult.proximityLayer = this.proximityLayer;
          finalResult.isMultiple = this.isProxyMultiple;
          this.getProximityOperationGeometry(finalResult);
          this.buttonLoader = false;
          this._isochroneService.openSnackBar("Your proximity result generated successfully", "snackbar-success", "success");
          this.stepper.selected.completed = true;
          this.stepper.next()
        });
        this.maphelperService.ListenMapPopup.next(true);
        this.draw.deleteAll();

      }
      else {
        this._isochroneService.openSnackBar("No Result Found", "snackbar-error", "fail");
        this.buttonLoader = false;
        this.maphelperService.ListenMapPopup.next(true);
      }

    }, err => {
      console.log("operation tool erro", err)
      this._isochroneService.openSnackBar("Operation tool Error", "snackbar-error", "fail");
      this.buttonLoader = false;
      this.maphelperService.ListenMapPopup.next(true);
    });



    // this.ShareMapService.queryTool(this.selectedLayerData ,this.query).subscribe(data=>{
    //   let jsonData = data.data.jsonb_build_object;
    //   if(jsonData){
    //     data = {queryData:jsonData,selectedLayer:this.selectedLayerData}
    //     this.proximityOperationGeometry.emit(data);
    //     }
    //   });

    // this.ShareMapService.proximityOperation(firstLayerSelected,secondLayerSelected,this.abc,circleradius,selectedOperation,length,selection).subscribe(result=>{
    //   let finalResult = result.data;
    //   this.maphelperService.getLayerJsonData(finalResult.dbzxvuwyacs,finalResult.view).subscribe(data => {
    //     this.onResetButton();
    //     let layerMapDetails = this.maphelperService.addLayers(data["id"], data["geometrytype"], data["tileurl"], this.mapCarto, "red");
    //      this.proximityLayer = layerMapDetails.source;
    //      this.isProxyMultiple = layerMapDetails.multiple;
    //      this.mapCarto = layerMapDetails.map;
    //      this.mapCarto.fitBounds(data['bounds']);
    //      finalResult.proximityLayer = this.proximityLayer;
    //      finalResult.isMultiple = this.isProxyMultiple;
    //      this.proximityOperationGeometry.emit(finalResult);
    //   });
    // },
    // error =>{
    // });
  }



  // selectedLayerData;
  // QueryToolGetResult(){
  //   console.log('selectedLayerData',this.selectedLayerData);
  //   console.log('query',this.query);
  //   this.ShareMapService.queryTool(this.selectedLayerData ,this.query).subscribe(data=>{
  //     let jsonData = data.data.jsonb_build_object;
  //     if(jsonData){
  //       data = {queryData:jsonData,selectedLayer:this.selectedLayerData}
  //       this.proximityOperationGeometry.emit(data);
  //       }
  //     });

  //   }




  onResetButton() {
    this.matSecondStep = false
    this.tab = "all";
    this.draw.deleteAll();
    this.abc = "";
    this.conditionalData = "";
    this.firstLayerSelected = undefined
    this.secondLayerSelected = undefined
    this.length = undefined
    this.maphelperService.removeLayerFromMap(this.mapCarto, this.proximityLayer, this.isProxyMultiple);
    // Reset the view - this will just delete the extra views created:
    this.downloadDisabled = false;
    this.publishLayerDisbled = false;
    this.isCircleBox = false;
    this.maphelperService.ListenMapPopup.next(true);
    this.setDefaultValueQueryBuilder();
    this.circleRadius1 = 100;

  }


  ToggleQueryBuilder() {
    this.IsQueryBuilder = !this.IsQueryBuilder
  }


  OnChangeCircleRadius(event) {

  }



  tab = "all"
  clickDrawBtn(check) {
    if (check == "all") {
      this.tab = "all"
    } else if (check == "circle") {
      this.tab = "circle"
    } else if (check == "rectangle") {
      this.tab = "rectangle"
    } else if (check == "polygon") {
      this.tab = "polygon"
    }
    else if (check == 'free-hand') {
      this.tab = 'free-hand'
    }
  }

  CheckLayer() {
    if (this.firstLayerSelected) {
      return false
    }
    return true
  }


  // download(){
  //   this.CsvFileDownloadService.createDownloadableCsvFromGeojson(this.jsonData);
  // }
  // publishAsNewLayer(){
  //   this.appAnalysisService.publishFilterDataAsLayer(this.layerIdForPublish,this.gidArray).subscribe(data=>{
  //     if(data){
  //       this.layerResfreshAfterPublish.emit(true)
  //       this.onResetButton()
  //     }
  //    });
  // }
  downloadExcelLoader = false
  proximitySchema
  proximityView
  proximityMultipleLayer
  totalResultSearch
  @Output() closeProximity = new EventEmitter<any>()
  closeProximityInShareMap() {
    this.closeProximity.emit()
  }

  getProximityOperationGeometry(proximityOperationGeometry) {
    this.totalResultSearch = proximityOperationGeometry.feature_count;
    this.proximitySchema = proximityOperationGeometry.dbzxvuwyacs;
    this.proximityView = proximityOperationGeometry.view;
    this.proximityMultipleLayer = proximityOperationGeometry.isMultiple;
  }

  downloadQuerySearchData() {
    this.downloadExcelLoader = true;
    this.appAnalysisService.downloadExcelOperationFile(this.proximitySchema, this.proximityView).subscribe(val => {
      if (val.http_code == 200) {
        this.downloadExcelLoader = false;
        let newWin = window.open(val.data);
        if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
          this._isochroneService.openSnackBar("Please Allow Browser Pop Up", "snackbar-error", "fail")
        }
        else {
          // this.router.navigateByUrl(`/analysis/map/${this.mapId}`)
          this.stepper.reset()
        }
      }
    }, err => { this.downloadExcelLoader = false; });
  }

  onResetProximity() {
    this.draw.deleteAll()
    this.onResetButton()
    this.maphelperService.removeLayerFromMap(this.mapCarto, this.proximityLayer, this.proximityMultipleLayer);
    // this.selectedQueryLayer="";
    this.proximitySchema = "";
    this.proximityView = "";
    this.proximityLayer = "";
    this.stepper.selectedIndex = 1;
    // this.queryData = false;
    // this.OperationResetFromMap = true;
  }
  publishLayerButtonLoader = false
  proximityPublishLayer() {
    this.publishLayerButtonLoader = true
    let raster
    if (this.firstLayerDetailsSelected.layer_type == "POINT") {
      raster = 0
    } else {
      raster = 1
    }
    this.appAnalysisService.proximityPublishLayer(this.proximitySchema, this.proximityView, raster).subscribe(data => {
      if (data) {
        let uploadedLayer = [data.data];
        this._isochroneService.openSnackBar("Your layer published successfully", "snackbar-success", "success");
        if (Array.isArray(data.data[0])) {
          // this.mapComponent.addLayerOnMapLayer(layer_details, null);
          this.addToMapLayers.emit(data.data[0])
        }
        else {
          let data2 = [data.data]
          this.addToMapLayers.emit(data2)
          // this.mapComponent.addLayerOnMapLayer(data2, null);
        }
        console.log(uploadedLayer)
        this.onResetProximity();
        // this.router.navigateByUrl(`/analysis/map/${this.mapId}`)
        this.stepper.reset()
        // this.addLayerOnMapLayer(uploadedLayer,0)
        this.publishLayerButtonLoader = false
      }
    },
      error => {
        this.publishLayerButtonLoader = false
        alert(error)
        this.stepper.selectedIndex = 1
      })
  }

  checkLayerType() {
    if (this.selectedOperation == "within" && this.selection == 'twoLayer') {
      console.log(this.firstLayerDetailsSelected)
      this.allLayersData.forEach(layer => {
        if (layer.layerid == this.secondLayerSelected) {
          this.secondLayerDetailsSelected = layer
          console.log('fetching attributes');
          this.attributes = layer.attributes;
          this.mapCarto.fitBounds(layer.fitBounds);
        }
      });
      console.log(this.secondLayerDetailsSelected)
    }
  }

  async layerCount(data) {

    if (!this.allLayersData) {
      this._isochroneService.openSnackBar("Please add layer for analysis", "snackbar-error", "fail")
      return
    }

    this.selection = data;
    // await this.matFirstStep = true
    this.stepper.selected.completed = true;
    // setTimeout(() => {
    this.stepper.next()

    // }, 100);
  }

  ngOnDestroy() {
    this.maphelperService.ListenMapPopup.next(true);
  }

  lastStepRecord
  Addclick() {
    if (this.visible_one && this.stepper) {
      let stepper: any = this.stepper
      this.lastStepRecord = stepper._selectedIndex
    } else {
      setTimeout(() => {
        for (let i = 0; this.lastStepRecord > i; i++) {
          this.stepper.selected.completed = true;
          this.stepper.next();
        }
      }, 100)
    }

    this.AddMore = !this.AddMore; //not equal to condition
    this.visible_one = !this.visible_one
  }
}

